import { cn } from "@gigpro/ui/tailwind/cn";
import { RadioGroup as RadioGroupPrimitive } from "radix-ui";
import type * as React from "react";
import { Circle } from "../../Icons";

const RadioGroup = ({ ref, className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Root>) => (
  <RadioGroupPrimitive.Root className={cn("grid gap-2", className)} {...props} ref={ref} />
);
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = ({
  ref,
  className,
  children,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) => (
  <RadioGroupPrimitive.Item
    ref={ref}
    className={cn(
      "flex size-[18px] shrink-0 items-center justify-center rounded-full border-2 border-brand text-brand ring-offset-brand focus:outline-none focus-visible:ring-2 focus-visible:ring-light-gray focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  >
    <RadioGroupPrimitive.Indicator asChild>
      <Circle className="size-[round(75%,2px)]" />
    </RadioGroupPrimitive.Indicator>
  </RadioGroupPrimitive.Item>
);
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
